<svg class="logo-bg logo-bg--ebox" width="347" height="376" viewBox="0 0 347 376" *ngIf="!partnerLogo; else partnerImageLogo">
    <use [attr.xlink:href]="'../../../../assets/images/sprite.svg#ebox-logo'"></use>
</svg>

<ng-template #partnerImageLogo>
    <img [src]="partnerLogo" alt="" class="logo-bg logo-bg--ebox">
</ng-template>

